import { atom } from "jotai";

/** 客服「Contact Us」弹窗开关状态 */
export const contactUsModalOpenAtom = atom(false);
